import Rarity from "../../helper/Rarity";
import IngredientCategory from "../../helper/IngredientCategory";

export default {
    ARACHAS: {
        item: 'Arachas Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    BEAR: {
        item: 'Bear Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    BOTCHLING: {
        item: 'Botchling Mutagen',
        category: IngredientCategory.RED_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    BRUXA: {
        item: 'Bruxa Mutagen',
        category: IngredientCategory.BLUE_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    BULLVORE: {
        item: 'Bullvore Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    COCKATRICE: {
        item: 'Cockatrice Mutagen',
        category: IngredientCategory.RED_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    ELEMENTAL: {
        item: 'Elemental Mutagen',
        category: IngredientCategory.BLUE_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    FIEND: {
        item: 'Fiend Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    FOGLET: {
        item: 'Foglet Mutagen',
        category: IngredientCategory.BLUE_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    FRIGTHENER: {
        item: 'Frightener Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    GARKAIN: {
        item: 'Garkain Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    GOLEM: {
        item: 'Golem Mutagen',
        category: IngredientCategory.BLUE_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    GRAVE_HAG: {
        item: 'Grave Hag Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    GRIFFIN: {
        item: 'Griffin Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    KATAKAN: {
        item: 'Katakan Mutagen',
        category: IngredientCategory.RED_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    LESHEN: {
        item: 'Leshen Mutagen',
        category: IngredientCategory.BLUE_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    MANTICORE: {
        item: 'Manticore Mutagen',
        category: IngredientCategory.RED_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    NEKKER: {
        item: 'Nekker Mutagen',
        category: IngredientCategory.RED_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.UNCOMMON,
    },
    NOONWRAITH: {
        item: 'Noonwraith Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    Penitent: {
        item: 'Penitent Mutagen',
        category: IngredientCategory.BLUE_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    PESTA: {
        item: 'Pesta Mutagen',
        category: IngredientCategory.BLUE_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    PHOENIX: {
        item: 'Phoenix Mutagen',
        category: IngredientCategory.RED_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    ROCK_TROLL: {
        item: 'Rock Troll Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    SHAELMAAR: {
        item: 'Shaelmaar Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    SIREN: {
        item: 'Siren Mutagen',
        category: IngredientCategory.BLUE_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    SUCCUBUS: {
        item: 'Succubus Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    TROLL: {
        item: 'Troll Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    VENDIGO: {
        item: 'Vendigo Mutagen',
        category: IngredientCategory.RED_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    WEREWOLF: {
        item: 'Werewolf Mutagen',
        category: IngredientCategory.RED_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
    WYVERN: {
        item: 'Wyvern Mutagen',
        category: IngredientCategory.RED_MUTAGEN,
        maxAmount: 1,
        DC: 16,
        rarity: Rarity.RARE,
    },
}